export class AppVersion {
public static appVersion = '1.1.715';
}
